<template>
  <div class="university-ranking-chart">
    <div class="text-center mb-4">{{ title }}</div>
    <div class="chart-container">
      <apexchart
        type="treemap"
        :options="chartOptions"
        :series="chartSeries"
        height="600"
      />
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { request } from "@/api/all";

export default {
  name: "UniversityRankingChart",
  components: {
    apexchart: VueApexCharts
  },
  props: {
    title: {
      type: String,
      default: "Төгссөн сургууль"
    }
  },
  data() {
    return {
      chartSeries: [
        {
          name: "Мэргэжилтнүүдийн тоо",
          data: []
        }
      ],
      chartOptions: {
        chart: {
          type: "treemap",
          height: 580,
          toolbar: {
            show: false
          }
        },
        colors: [
          "#4299E1",
          "#5D69C7",
          "#7B68EE",
          "#9370DB",
          "#BA55D3",
          "#DA70D6",
          "#EE82EE",
          "#FF69B4",
          "#FF1493",
          "#DC143C",
          "#B22222",
          "#CD5C5C",
          "#F08080",
          "#FA8072",
          "#E9967A",
          "#FFA07A",
          "#FFB6C1",
          "#FFC0CB",
          "#FFE4E1",
          "#FFF0F5"
        ],
        plotOptions: {
          treemap: {
            enableShades: true,
            shadeIntensity: 0.5,
            reverseNegativeShade: true,
            colorScale: {
              ranges: [
                {
                  from: -6,
                  to: 0,
                  color: "#CD363A"
                },
                {
                  from: 0.001,
                  to: 6,
                  color: "#52B12C"
                }
              ]
            }
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: "12px",
            fontWeight: "bold",
            colors: ["#fff"]
          },
          formatter: function(text, op) {
            return [text, op.value];
          },
          offsetY: -4
        },
        tooltip: {
          y: {
            formatter: function(val) {
              return val + " хүн";
            }
          }
        },
        legend: {
          show: false
        }
      }
    };
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      request({
        api: {
          url: "/reportV2/Export",
          method: "POST"
        },
        data: {
          procName: "egazar_chart9",
          exportMode: 2,
          params: []
        }
      }).then(res => {
        if (res != false) {
          console.log("egazar_chart9 data:", res.data);
          this.updateChartData(res.data);
        }
      });
    },
    updateChartData(data) {
      if (data && data.length > 0) {
        // st6, count бүтэцтэй датаг treemap форматд өөрчлөх
        const allData = data.map(item => ({
          x: item.st6,
          y: parseInt(item.count)
        }));

        // Count нь 1-ээс их байгаа элементүүд
        const mainData = allData.filter(item => item.y > 1);
        
        // Count нь 1-тэй тэнцүү байгаа элементүүд
        const singleItems = allData.filter(item => item.y === 1);
        
        // Нэг хүнтэй их сургуулуудын нийт тоо
        const othersCount = singleItems.length;
        
        let treemapData = [...mainData];
        
        // Хэрэв 1 хүнтэй их сургууль байвал "Бусад" гэж нэгтгэх
        if (othersCount > 0) {
          treemapData.push({
            x: "Бусад",
            y: othersCount
          });
        }

        // Их утгуудын дагуу эрэмбэлэх
        treemapData.sort((a, b) => b.y - a.y);

        // Chart серийг шинэчлэх
        this.chartSeries = [
          {
            name: "Мэргэжилтнүүдийн тоо",
            data: treemapData
          }
        ];

        console.log("Treemap data:", treemapData);
        console.log(`Нийт ${othersCount} их сургууль "Бусад" бүлэгт нэгтгэгдсэн`);
      }
    }
  }
};
</script>

<style scoped>
.university-ranking-chart {
  padding: 20px;
}

.chart-container {
  max-width: 100%;
  overflow-x: auto;
}
</style>
